export class ApiError extends Error {
  constructor(
    message: string,
    readonly status?: number,
    readonly correlationId?: string
  ) {
    super(message);
    this.name = "ApiError";
  }
}

export class ParseError extends Error {
  constructor(message: string, readonly data: unknown) {
    super(message);
    this.name = "ParseError";
  }
}






